<template>
    <navbar v-model="showNavbar">
        <div class="navbar-wrapper">
            <div class="logo">
                <router-link to="/platform/projects">
                    <a class="simple-text logo-mini">
                        <div class="logo-img">
                            <img height="50" :src="logo" alt="">
                        </div>
                    </a>
                </router-link>
            </div>
        </div>
        <template slot="navbar-menu">
            <ul class="navbar-nav navbar-all-nav">
                <!-- <li><LocaleSwitcher /></li> -->
                <li class="nav-icon-item">
                    <div class="notification-icon-wrapper">
                        <div v-if="unreadNotificationCount!=='0'" class="notification-red-badge">{{
                                unreadNotificationCount
                            }}
                        </div>
                        <a class="nav-link nav-icon ti-bell" title="Notifications"
                           @click="userNotificationsPage"></a>
                    </div>
                </li>
                <li class="nav-icon-item">
                    <a class="nav-link nav-icon ti-help" title="Need help?" href="#"
                       @click="showHelpModal()"></a>
                </li>
                <li class="nav-icon-item">
                    <a class="nav-link nav-icon ti-flag-alt" title="Report an Issue"
                       @click="showReportIssueModal()"></a>
                </li>

                <drop-down icon="nc-icon nc-bell-55" tag="li" position="right" direction="none"
                           class="nav-item dropdown user-dropdown">
                    <a slot="title" slot-scope="{isOpen}" class="nav-link dropdown-toggle dropdown-toggle-name user-dropdown-toggle"
                       aria-haspopup="true" :aria-expanded="isOpen">
                        <span class="user-name-wrapper">
                            <span class="user-avatar">{{ getUserInitials() }}</span>
                            <span class="user-name" :title="username">{{ username }}</span>
                            <i class="dropdown-caret" :class="{'rotated': isOpen}"></i>
                        </span>
                    </a>
                    <router-link to="/platform/user/profile" class="dropdown-item-link">
                        <a class="dropdown-item modern-dropdown-item">
                            <i class="ti-user dropdown-item-icon"></i>
                            <span class="sidebar-normal">My Profile</span>
                        </a>
                    </router-link>

                    <router-link to="/platform/user/organisation" class="dropdown-item-link">
                        <a class="dropdown-item modern-dropdown-item">
                            <i class="ti-settings dropdown-item-icon"></i>
                            <span class="sidebar-normal">Organisation Settings</span>
                        </a>
                    </router-link>

                    <div class="dropdown-divider"></div>

                    <div class="site-zoom-control">
                        <site-zoom-control></site-zoom-control>
                    </div>
                    
                    <div class="dropdown-divider"></div>

                    <router-link to="" tag="a">
                        <a class="dropdown-item modern-dropdown-item logout-item" @click="logout()">
                            <i class="ti-power-off dropdown-item-icon"></i>
                            <span class="sidebar-normal">Logout</span>
                        </a>
                    </router-link>

                </drop-down>

            </ul>
        </template>
        <help-modal ref="helpModal2"></help-modal>
        <report-issue-modal ref="reportIssueModal"></report-issue-modal>
    </navbar>
</template>
<script>
import {Navbar, NavbarToggleButton, SiteZoomControl} from '../UIComponents';
import HelpModal from "./HelpModal.vue";
import ReportIssueModal from "./ReportIssueModal.vue";
import LocaleSwitcher from "../../LocaleSwitcher.vue"

export default {
    components: {
        Navbar,
        NavbarToggleButton,
        "help-modal": HelpModal,
        "report-issue-modal": ReportIssueModal,
        LocaleSwitcher,
        SiteZoomControl
    },
    data()
    {
        return {
            activeNotifications: false,
            showNavbar: false,
            userImage: '',
            username: '',
            helpLinkUrl: 'URL',
            unreadNotificationCount: '0',
            notificationCheckTimer: null,
        };
    },
    props: {
        usertype: {
            type: String,
        },
    },
    methods: {
        getUserInitials()
        {
            if (!this.username) return '';
            const names = this.username.trim().split(' ');
            if (names.length >= 2) {
                return (names[0][0] + names[names.length - 1][0]).toUpperCase();
            }
            return names[0].substring(0, 2).toUpperCase();
        },
        userNotificationsPage()
        {
            //this.$router.push({'name': 'userNotifications',});
            window.Bus.$emit('open-notification-panel')
        },
        capitalizeFirstLetter(string)
        {
            return string.charAt(0).toUpperCase() + string.slice(1);
        },
        toggleNotificationDropDown()
        {
            this.activeNotifications = !this.activeNotifications;
        },
        closeDropDown()
        {
            this.activeNotifications = false;
        },
        toggleSidebar()
        {
            this.$sidebar.displaySidebar(!this.$sidebar.showSidebar);
        },
        hideSidebar()
        {
            this.$sidebar.displaySidebar(false);
        },
        minimizeSidebar()
        {
            this.$sidebar.toggleMinimize();
        },
        toggleNavbar()
        {
            this.showNavbar = !this.showNavbar;
        },
        showModal()
        {
            //    Bus.$emit("showmodal",true);
            var pageUrl = location.href;
            var res = pageUrl.split("/");
            var pageName = res[3];
            var faqpage = "https://hsappsinternal.wiki.zoho.com/FAQ.hlp#" + pageName;
            if (pageName == "projects" || pageName == "fieldteams") {
                window.open(faqpage, 'popUpWindow', 'height=900,width=1000,left=100,top=70,resizable=yes,scrollbars=yes,toolbar=yes,menubar=no,location=no,directories=no, status=yes');
            }
        },
        async logout()
        {
            this.$store.dispatch('LogOut');
        },
        notifications()
        {
            let vm = this;
            axios.get('user/notifications').then(response => {
                if (response.data.response.error.error_code == 0) {
                    vm.unreadNotificationCount = response.data.response.data.unread_count;
                }
            }).catch(error => {
                console.log(error)
            });
        },
        showHelpModal()
        {
            this.$refs.helpModal2.loadUrl(window.USER_MANUAL_URL);
        },
        showReportIssueModal()
        {
            this.$refs.reportIssueModal.openModal();
        }
    },
    computed: {
        appName()
        {
            return window.AppName;
        },
        title()
        {
            return window.appConfig.appName;
        },
        logo(){
            return window.appConfig.logo;
        }
    },
    mounted()
    {
        this.helpLinkUrl = window.USER_MANUAL_URL;
        var vm = this;
        vm.notifications();

        vm.notificationCheckTimer = setInterval(() => {
            vm.notifications();
        }, 1000 * 60)

        this.$root.$on('userDataSet', () => {
            const userData = JSON.parse(localStorage.getItem('userdata'));
            vm.username = userData.userName;
            const user_image = userData.userImage;
            if (user_image == null || user_image == '') {
                vm.userImage = window.DefaultUserImage;
            } else {
                vm.userImage = user_image;
            }
        });

        /*Bus.$on('userData', data => {
            var user_image = data.photo_url;
            var user_name = data.first_name + ' ' + data.last_name;
            vm.username = user_name;
            vm.userimage = user_image;
            if (user_image == null || user_image == '') {
                vm.userImage = window.DefaultUserImage;
            } else {
                vm.userImage = user_image;
            }
        });*/
    },
    beforeDestroy()
    {
        clearInterval(this.notificationCheckTimer)
    }
}

</script>
<!--pradeep -->
<style lang="scss" scoped>
/* Navbar Icon Improvements */
.navbar-nav.navbar-all-nav {
    display: flex;
    align-items: center;
}

.nav-icon-item {
    margin: 0 8px;
    display: flex;
    align-items: center;
}

.nav-icon {
    font-size: 22px !important;
    cursor: pointer;
    color: #66615B;
    transition: all 0.3s ease;
    padding: 10px !important;
    border-radius: 8px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
}

.nav-icon:hover {
    color: #1e88e5;
    background-color: rgba(30, 136, 229, 0.08);
    transform: scale(1.05);
}

/* User Avatar */
.user-avatar {
    width: 32px;
    height: 32px;
    border-radius: 50%;
    background: #1e88e5;
    color: white;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    font-weight: 600;
    font-size: 12px;
    margin-right: 8px;
    letter-spacing: 0.5px;
}

.user-name-wrapper {
    display: flex;
    align-items: center;
    padding: 6px 12px;
    border-radius: 24px;
    transition: all 0.3s ease;
}

.user-name-wrapper:hover {
    background-color: rgba(102, 97, 91, 0.05);
}

.user-dropdown-toggle {
    color: #66615B !important;
}

.user-dropdown {
    display: flex;
    align-items: center;
}

.dropdown-caret {
    display: inline-block;
    margin-left: 8px;
    width: 0;
    height: 0;
    border-left: 4px solid transparent;
    border-right: 4px solid transparent;
    border-top: 5px solid #66615B;
    transition: transform 0.3s ease;
}

.dropdown-caret.rotated {
    transform: rotate(180deg);
}

/* Modern Dropdown Styling */
.user-dropdown .dropdown-menu {
    border-radius: 12px !important;
    box-shadow: 0 10px 40px rgba(0, 0, 0, 0.12) !important;
    border: 1px solid rgba(0, 0, 0, 0.05) !important;
    padding: 8px 0 !important;
    min-width: 280px;
    margin-top: 8px !important;
    overflow: hidden;
}

.user-dropdown .dropdown-menu .dropdown-item-link {
    text-decoration: none !important;
}

.user-dropdown .dropdown-menu .dropdown-item-link:hover {
    text-decoration: none !important;
}

.user-dropdown .dropdown-menu a {
    text-decoration: none !important;
}

.user-dropdown .dropdown-menu a:hover {
    text-decoration: none !important;
}

.modern-dropdown-item {
    display: flex !important;
    align-items: center;
    padding: 12px 20px !important;
    transition: all 0.2s ease !important;
    color: #333 !important;
    font-size: 14px;
    border-radius: 0 !important;
    text-decoration: none !important;
}

.modern-dropdown-item .sidebar-normal {
    color: #333 !important;
}

.modern-dropdown-item:hover {
    background-color: rgba(30, 136, 229, 0.08) !important;
    color: #1e88e5 !important;
    text-decoration: none !important;
}

.modern-dropdown-item:hover .dropdown-item-icon {
    color: #1e88e5;
}

.modern-dropdown-item:hover .sidebar-normal {
    color: #1e88e5 !important;
}

.dropdown-item-icon {
    margin-right: 12px;
    font-size: 18px;
    width: 20px;
    min-width: 20px;
    color: #66615B;
    transition: color 0.2s ease;
    transform: rotate(0deg) !important;
    display: inline-flex;
    align-items: center;
    justify-content: center;
}

.logout-item:hover {
    background-color: rgba(244, 67, 54, 0.08) !important;
    color: #f44336 !important;
}

.logout-item:hover .dropdown-item-icon {
    color: #f44336;
}

.logout-item:hover .sidebar-normal {
    color: #f44336 !important;
}

.dropdown-divider {
    margin: 8px 0;
    border-top: 1px solid rgba(0, 0, 0, 0.06);
}

.site-zoom-control {
    padding: 16px 20px !important;
    display: flex;
    justify-content: center;
    align-items: center;
    white-space: nowrap;
    background-color: rgba(0, 0, 0, 0.02);
}
.setnavbarbgcolor {
    background-color: white !important;
}

#show-modal {
    cursor: pointer;
}

.remove-color:hover {
    color: #66615B !important;
}

.badge {
    position: absolute;
    top: -14px;
    right: -6px;
    padding: 3px 7px 5px 7px;
    border-radius: 50%;
    background-color: red;
    color: white;
}

.user-name {
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
    max-width: 120px;
    font-weight: 500;
    font-size: 14px;
    color: #333;
}

.dropdown-toggle-name::after {
    display: none !important;
}

@media (max-width: 800px) {
    .navbar-all-nav {
        flex-direction: row;
        margin-top: 30px;
    }

    .dropdown-icon {
        margin-top: 0px !important;
    }
}

.notification-red-badge {
    position: absolute;
    right: 5px;
    top: 5px;
    padding-left: 3px;
    padding-right: 3px;
    background: #f44336;
    text-align: center;
    margin: 0;
    font-size: 10px;
    color: white;
    font-weight: 600;
    border-radius: 30px;
    height: 18px;
    min-width: 18px;
    display: flex;
    align-items: center;
    justify-content: center;
    box-shadow: 0 2px 8px rgba(244, 67, 54, 0.4);
    animation: pulse 2s ease-in-out infinite;
}

@keyframes pulse {
    0%, 100% {
        transform: scale(1);
    }
    50% {
        transform: scale(1.1);
    }
}

.notification-icon-wrapper {
    position: relative;
    display: flex;
    align-items: center;
}
</style>
<!--End-->
